import React from 'react'

function Footer() {
    return (
        <div>
            <div>
                <nav class="bg-gray-wed">
                    <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
                        <div class="relative flex items-center justify-between h-16">
                            <div class="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                                <div class="flex space-x-5 text-white text-lg">
                                    <a href="https://github.com/amarkusuma"><i class="fab fa-instagram-square"></i></a>
                                    <a href="https://github.com/amarkusuma"><i class="fab fa-facebook-square"></i></a>
                                    <a href="https://github.com/amarkusuma"><i class="fab fa-pinterest-square"></i></a>
                                    <a href="https://github.com/amarkusuma"><i class="fab fa-github"></i></a>
                                    <a href="https://github.com/amarkusuma"><i class="fab fa-whatsapp-square"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    )
}

export default Footer
